'use client';

import { CommandGroup, CommandItem } from '@/components/ui/command';
import { useMemo } from 'react';
import { ItemIcon } from '../primitives';
import type { CommandPickerItem } from '../types';

export function StaticPicker({
  term,
  heading,
  items,
  emptyLabel,
  onDone,
}: {
  term: string;
  heading: string;
  items: CommandPickerItem[];
  emptyLabel: string;
  onDone: () => void;
}) {
  const filtered = useMemo(() => {
    const lower = term.trim().toLowerCase();
    if (!lower) return items;
    return items.filter((item) => item.label.toLowerCase().includes(lower));
  }, [items, term]);

  if (filtered.length === 0) {
    return (
      <div className="text-muted-foreground/60 px-3 py-4 text-center text-sm">
        {emptyLabel}
      </div>
    );
  }

  return (
    <CommandGroup heading={heading}>
      {filtered.map((item) => {
        const Icon = item.icon;
        return (
          <CommandItem
            key={item.id}
            value={`picker:${item.id}`}
            onSelect={() => {
              void Promise.resolve(item.onSelect())
                .catch((error) => {
                  console.error('Command picker item selection failed:', error);
                })
                .finally(onDone);
            }}
          >
            {Icon && <ItemIcon icon={Icon} />}
            <span className="min-w-0 flex-1 truncate">{item.label}</span>
            {item.hint && (
              <span className="text-muted-foreground/40 text-xs">
                {item.hint}
              </span>
            )}
          </CommandItem>
        );
      })}
    </CommandGroup>
  );
}
